import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, CircularProgress } from '@material-ui/core';
import "./Breakdown.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import PowerIcon from '@material-ui/icons/Power';
import { getBDStatus, getBreakdowns, } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';


const RootCauseAnalysis = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
    ];

    const [loading, setLoading] = useState(true);
    const [breakDowns, setBreakdowns] = useState([]);

    const getPriorityClass = (priority) => {
        switch (priority.toLowerCase()) {
            case 'high':
                return 'high-priority';
            case 'medium':
                return 'medium-priority';
            case 'low':
                return 'low-priority';
            default:
                return '';
        }
    };

    const reports = JSON.parse(localStorage.getItem("root")) || [];
    console.log("reports:", reports);
    const navigate = useNavigate();

    const handler = (item) => {
        navigate(`/breakdown-management/why-why-analysis/${item.id}`)
    }

    const getBreakDowns = async (id) => {
        try {
            const action = dispatch(getBreakdowns(`?status_id=${id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdowns(res.result.breakdowns);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const getStatus = async () => {
        try {
            const action = dispatch(getBDStatus());
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                const rootAnalysis = res.result.bd_status.find(item => item.status === "root-analysis");
                const rootAnalysisID = rootAnalysis ? rootAnalysis.id : null;
                if (rootAnalysisID) {
                    await getBreakDowns(rootAnalysisID)
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };


    useEffect(() => {
        let isMounted = true;  // Track if the component is still mounted

        const fetchData = async () => {
            try {
                await getStatus();
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        // Cleanup function to prevent state update on unmounted component
        return () => {
            isMounted = false;
        };
    }, []);


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Root Cause Analysis" />
                </Box>
                {/* <Box mb={2}>
                    {reports.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Breakdown for Root Cause Analysis</Typography>
                        </Box>
                    ) : (<Grid container spacing={4}>
                        {reports.map((item, index) => (
                            <Grid item xs={6} sm={3} key={index} onClick={() => handler(item)}>
                                <div className='breakdown-card'>
                                    <div className={`card-header ${getPriorityClass(item.priority)}`}>
                                        <span>
                                            <PowerIcon />
                                        </span>
                                        {item.assetDescription} ({item.assetNo})</div>
                                    <h4>{item.assetDescription}</h4>
                                    <p>Category: {item.nature}</p>
                                    <p>Reason: {item.reason}</p>
                                    <p>Priority: {item.priority}</p>
                                </div>
                            </Grid>
                        ))}

                    </Grid>)}

                </Box> */}

                <Box mb={2}>
                    {breakDowns.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <PowerIcon style={{ fontSize: 40, marginRight: 8 }} />
                            <Typography variant="h5">No Breakdown for Root Cause Analysis</Typography>
                        </Box>
                    ) : (<Grid container spacing={4}>
                        {breakDowns && breakDowns.map((item, index) => (
                            <Grid item xs={12} sm={3} key={index} onClick={() => handler(item)}>
                                <div className='breakdown-card'>
                                    <div className={`card-header ${getPriorityClass(item.priority)}`}>
                                        <span>
                                            <PowerIcon />
                                        </span>
                                        {item.machine_details.asset_text} ({(item.machine_details.asset_no).slice(3)})
                                    </div>
                                    <h4>{item.machine_details.asset_text}</h4>
                                    <p><span>Category:</span> {item.reason.category_name}</p>
                                    <p><span>Reason:</span> {item.reason.name}</p>
                                    <p><span>Priority:</span> {item.priority}</p>
                                    <p><span>Status:</span> {item.status}</p>
                                    <p><span>Reported by:</span> {item.reported_by}</p>
                                    <p><span>Reported at:</span> {convertUTCtoIST(item.reported_at)}</p>
                                    {item.attended_by && (
                                        <p><span>Attended by:</span> {item.attended_by}</p>
                                    )}
                                </div>
                            </Grid>
                        ))}


                    </Grid>)}

                </Box>
            </Container>
            <ToastContainer />
        </Layout >
    );
};

export default RootCauseAnalysis;
